/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { Checkbox, Image, Input, PaperIcon } from '@nackle/paper';
import Editor from '@nackle/ecard-editor';
import '@nackle/ecard-editor/dist/editor.css';
import { LocaleString, getString } from '@nackle/intl-tools';
import { setMessage, setSelectedEcard, setPrivate } from './actions';
import { getMessage, getPrivate, getSelectedEcard } from './selectors';
import { getEcards, getSelectedProgram } from '../program/selectors';
import { XIcon } from '../../shared/icons/icons';
const { TextArea } = Input;
import { ecardUrl } from '../../../endpoints';

export default function Message( props ) {
    const {  forward, user } = props;

    const dispatch = useDispatch();
    const ecards = useSelector( ( state ) => getEcards( state ) );
    const messageValue = useSelector( ( state ) => getMessage( state ) );
    const selectedEcard = useSelector( ( state ) => getSelectedEcard( state ) );
    const selectedProgram = useSelector( ( state ) => getSelectedProgram( state ) );
    const isPrivate = useSelector( ( state ) => getPrivate( state ) );

    const [ animate, setAnimate ] = useState( false );
    const [ eCardEditorState, setEcardEditorState ] = useState( {} );
    const [ eCardPickerOpen, setEcardPickerOpen ] = useState( false );

    const privateOnly = selectedProgram.visibility && selectedProgram.visibility.length === 1;
    const publicOnly = selectedProgram.visibility && selectedProgram.visibility.length === 1 && selectedProgram.visibility[ 0 ] === 'PUBLIC' ;
        
    useEffect( () => {
        setAnimate( true );
    }, [] );

    const handleEcardSelection = ( option ) => {
        const emptyOption = Object.keys( option ).length === 0;
        dispatch( setSelectedEcard( option ) );
        //If the option was empty (the user removed the card) clear out the eCardEditorState.
        if ( emptyOption )
        {
            setEcardEditorState( {} );
        }
    };

    const editImage = () => {
        dispatch( setSelectedEcard( {} ) );
        //const { eCardPickerOpen } = this.state;
        setEcardPickerOpen( !eCardPickerOpen );
    };

    const onEcardSave = ( item ) => {
        let { ecardText } = item;
        if ( !ecardText )
        {
            ecardText = '';
        }
        setEcardPickerOpen( false );
        setEcardEditorState( { ...item, ecardText } );
    };

    return (
        <>
        <CSSTransition
        timeout={ 1000 }
        in={ animate }
        classNames={ forward ? 'slide-in' : 'slide-out' }>
            
            <div className='message-container'>
                <span className='input-label'><LocaleString code='recognition.message.header'/></span>
                <span className='input-label-extra'><LocaleString code='recognition.header.required'/></span>
                <TextArea className='message-input'
                            aria-label={ getString( 'recognition.header.required' ) }
                            autoFocus
                            bordered={ false }
                            value={ messageValue } 
                            onChange={ ( event ) => dispatch( setMessage( event.target.value ) ) } 
                            rows={ 4 }
                            //showCount 
                            maxLength={ 2000 } />
                { !publicOnly && 
                    <div className='private-container'>
                        <Checkbox disabled={ privateOnly } onChange={ ( event ) => dispatch( setPrivate( event.target.checked ) ) } checked={ isPrivate }>
                            <LocaleString code='recognition.message.private' />
                        </Checkbox>
                    </div>
                }
                { ecards && ecards.length > 0 &&
                <div style={ { paddingTop: '10px', paddingBottom: '20px' } }>
                    <span className='input-label'><LocaleString code='recognition.message.cardHeader' /></span>
                    <span className='input-label-extra'><LocaleString code={ selectedProgram.ecardRequired ? 'recognition.header.required' : 'recognition.header.optional' } /></span>
                </div>
                }
                { selectedEcard && selectedEcard.images &&
                    <div className="ecard-image-selected">
                        <Image
                            alt=""
                            width="100%"
                            onClick={ editImage }
                            src={ `${ ecardUrl }/companies/${ user.claims.company_id }/ecards/${ selectedEcard.id }/locales/${ user.claims.locale }` }
                            preview={ false } />
                        <PaperIcon icon={ <XIcon fill="#FFFFFF"/> } className="close-icon" originalSize={ true } onClick={ () => handleEcardSelection( {} ) } />
                    </div>
                }
            </div>
            
        </CSSTransition>
        {
                    ( ( ecards && ecards.length > 0 && !selectedEcard.images ) || eCardPickerOpen ) &&
                <div className='ecards-container'>
                    <Editor
                        ecards={ ecards }
                        token={ user.access_token }
                        setEcardImage={ handleEcardSelection }
                        open={ eCardPickerOpen }
                        toggleOpen={ editImage }
                        className='ecard-hatch'
                        drawerClass='ecard-drawer'
                        locale={ user.claims.locale }
                        ecardState={ eCardEditorState }
                        onSave={ onEcardSave }
                        companyId={ user.claims.company_id }
                    />
                </div>
                }
                </>
    );
}
